<script setup>
import { ref } from 'vue'
import { usePaymentStore } from '@/stores/payment.js'
import { useUserStore } from '@/stores/user.js'
import ModalWindow from '@/components/Functional/ModalWindow.vue'
import AppEnterYourEmailModal from '@/components/App/AppEnterYourEmailModal.vue'
import { createComponent } from '@/helpers/utils.js'

const paymentStore = usePaymentStore()
const userStore = useUserStore()
const loading = ref(false)

function openAppEnterYourEmailModal (props = {}) {
  const modalProps = {
    wrapperClass: 'max-w-md m-auto w-full h-full flex mt-4'
  }

  createComponent(ModalWindow, modalProps, AppEnterYourEmailModal, props)
}

async function addCard () {
  await paymentStore.checkoutSessionCreate({
    successUrl: `${window.origin}/checkout/result?is=success&type=add-card`,
    cancelUrl: `${window.origin}/checkout/result?is=cancel&type=add-card`,
    savePaymentMethod: true
  })
}

async function checkAddingCard () {
  loading.value = true

  try {
    if (!userStore.user.email) {
      openAppEnterYourEmailModal({
        callback: addCard
      })
    } else {
      await addCard()
    }
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <button
    v-if="paymentStore.paymentProcessor === 'stripe'"
    type="button"
    class="relative"
    @click="checkAddingCard">
    <span
      v-show="loading"
      class="loader w-4 h-4 !border-2 absolute -left-5 top-0 bottom-0 m-auto"/>

    {{ $t('user.me.add_card') }}
  </button>
</template>